/* React */
import React from "react";

/* Helper */
import { getStatusMapping } from "src/components/insights/custom-cohorts/status-container/getStatusMapping";

/* Stylesheet */
import styles from "./StatusContainer.module.scss";

/* Interfaces */
interface StatusProps {
  status?: string;
  createdAt?: string;
  modifiedAt?: string;
}

const Status: React.FC<StatusProps> = ({ status }) => {
  const statusData = getStatusMapping(status!);

  return status ? (
    <div className={styles.status_container}>
      <div
        style={{ background: statusData?.color }}
        className={`${styles.status} ${styles.label}`}
      >
        {statusData?.label}
      </div>
    </div>
  ) : (
    <div />
  );
};

export default Status;
